/* NTRL1 · Portada por pack: al elegir un pack, la galería muestra su portada como primera imagen
   y después solo las imágenes generales del producto (las portadas de los otros packs no aparecen).
   La portada de cada pack es la foto asignada a esa variante en Shopify (Producto > Variantes > imagen). */
(function () {
  if (window.__ntrlPackPhoto) return;
  window.__ntrlPackPhoto = true;

  function show(input) {
    if (!input) return;
    var hero = input.closest('.ntrl-hero');
    var gal = hero && hero.querySelector('.ntrl-gallery');
    if (gal && gal.__ntrlGallery) gal.__ntrlGallery.setCover(input.value);
  }
  function current() {
    document.querySelectorAll('.ntrl-hero [data-ntrl-packs]').forEach(function (packs) {
      show(packs.querySelector('.ntrl-pack__input:checked'));
    });
  }
  function start() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('ntrl-pack__input')) show(t);
    });
    // la galería se inicia con ntrl-pdp.js (defer): sincroniza cuando ya existe
    var tries = 0;
    (function wait() {
      var g = document.querySelector('.ntrl-hero .ntrl-gallery');
      if (g && g.__ntrlGallery) return current();
      if (++tries < 40) setTimeout(wait, 100);
    })();
    window.addEventListener('pageshow', function (e) { if (e.persisted) current(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
